export const RestrictionTagType = {
  LOCATION: "location",
  GEOGRAPHY: "geography",
  CATEGORY: "category",
  PRODUCT: "product",
  WEIGHT: "weight",
  VALUE: "value",
} as const;

export type RestrictionTagType =
  typeof RestrictionTagType[keyof typeof RestrictionTagType];

export default RestrictionTagType;
